module.exports = __webpack_public_path__ + "static/media/logo-comune-mantova-bianco.698442da.svg";